export enum TemporaryFileTypeEnum {
  GraphicalApprovalDocument = 1,
  CustomizationRequestMessageAttachment = 2,
  ExpiviConfigurationImage = 3,
}

// Enum per il backend - TemporaryFileReason da Swagger
export enum TemporaryFileReason {
  Unknown = 0,
  CustomizationRequestGraphicalApprovalDocument = 1,
  CustomizationRequestMessageAttachment = 2,
  CustomizationRequestMedia = 3,
  CustomizationRequestGraphicalApprovalImage = 4
}
